import { render, staticRenderFns } from "./WxShare.vue?vue&type=template&id=0bea0d5d&scoped=true"
import script from "./WxShare.vue?vue&type=script&lang=js"
export * from "./WxShare.vue?vue&type=script&lang=js"
import style0 from "./WxShare.vue?vue&type=style&index=0&id=0bea0d5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bea0d5d",
  null
  
)

export default component.exports